export class SimLookupToken {
  static ISimLookupRepository = Symbol("ISimLookupRepository");
  static SimLookupUseCase = Symbol("SimLookupUseCase");
  static SimLookupViewModel = Symbol("SimLookupViewModel");
}